import { buildFieldSurfaceStyleFromKiot, type FieldSurfaceDefaults } from './types'

/**
 * Base ô lọc trên header / toolbar (thanh tìm + popover Tune).
 * Tạm giống form — chỉnh file này khi cần style riêng.
 */
const baseFilterToolbarStyle = buildFieldSurfaceStyleFromKiot()

export const FILTER_TOOLBAR_FIELD_SURFACE_STYLE = {
  ...baseFilterToolbarStyle,
  // Label nổi trên viền input trong dropdown filter.
  labelFontSizePx: baseFilterToolbarStyle.labelFontSizePx + 4,
  // Focus border in dropdown filter should look lighter.
  focusShadow: 'none',
}

export const FILTER_TOOLBAR_FIELD_SURFACE_DEFAULTS: FieldSurfaceDefaults = {
  labelLayout: 'outline',
  labelShrink: true,
  size: 'small',
  variant: 'outlined',
  fullWidth: true,
}
